import styled from "styled-components";

export const TWITTER_IMAGE_SIZE_SPEC = {
  // 1.91:1 = 468:245
  web: {
    width: 578,
    pictureWidth: 468,
    minHeight: 245,
    maxHeight: 468
  },
  mobile: {
    width: 578,
    pictureWidth: 468,
    minHeight: 245,
    maxHeight: 468
  }
};

export const displayLinkStyle = {
  fontSize: "14px",
  lineHeight: "16px",
  color: "#657786",
  textAlign: "left"
};

export const titleStyle = {
  fontSize: "14px",
  lineHeight: "16px",
  textAlign: "left"
};

export const subHeadlineStyle = {
  fontSize: "14px",
  lineHeight: "16px",
  color: "#657786",
  textAlign: "left"
};

export const teaserTextStyle = {
  fontSize: "14px"
};

export const PostEditorWrapper = styled.div`
  display: flex;
  padding: 10px 32px 10px 15px;
  background: #fff;
  border: 1px solid #e8e8eb;
  box-shadow: 0px 2px 4px 0px #1516331f;
  border-radius: 4px;
  ${(props) =>
    props.mobile
      ? `
    width: ${TWITTER_IMAGE_SIZE_SPEC.mobile.width}px;
  `
      : `
    width: ${TWITTER_IMAGE_SIZE_SPEC.web.width}px;
  `}
`;

export const Logo = styled.img`
  width: 49px;
  height: 49px;
  border-radius: 100%;
  margin-right: 15px;
`;

export const BodyWrapper = styled.div`
  width: 100%;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-left: -6px;
`;

export const TwitterAddressWrapper = styled.div`
  color: #657786;
`;

export const EditorWrapper = styled.div`
  width: 100%;
  margin-left: -10px;
`;

export const LinkWrapper = styled.div`
  margin-top: 4px;
  border-radius: 14px;
  border: 1px solid #e8e8eb;
  width: ${(props) =>
    props.mobile
      ? TWITTER_IMAGE_SIZE_SPEC.mobile.pictureWidth
      : TWITTER_IMAGE_SIZE_SPEC.web.pictureWidth};
`;

export const ChannelDataEditorsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: fit-content;
  align-items: stretch;
  padding: 7px 4px 10px;
`;

export const FooterWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 10px 100px 0 0;
`;

export const TwitterButton = styled.button`
  width: 35px;
  height: 35px;
  background-color: transparent;
  border-radius: 100%;
  border: none;
  color: #657786;
  transition: all 0.2s;
  cursor: pointer;
  &:hover {
    color: ${(props) => props.color};
    background-color: ${(props) => props.color}10;
  }
`;

export const DisplayLinkWrapper = styled.div`
  color: #657786;
  display: flex;
  svg {
    width: 16px;
    margin-left: 6px;
  }
`;

export const PageName = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #14171a;
  padding: 3px 6px;
`;
